import * as Types from '../../../../__generated__/schema';

import {
  ActorTeaserAPIToken,
  ActorTeaserUser,
} from '../../../graphql/fragments/ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from '../../../graphql/fragments/ActorTeaser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AIConversationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  streamsInput?: Types.InputMaybe<Types.AIConversationStreamsInput>;
}>;

export type AIConversation = {
  aiConversation: Pick<
    Types.AIConversation,
    'id' | 'title' | 'private' | 'saved' | 'canEdit' | 'isOwner' | 'createdAt' | 'updatedAt'
  > & {
    createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser>;
    streams: {
      edges: Array<{
        node: Pick<
          Types.AIInferenceStream,
          | 'streamId'
          | 'userPrompt'
          | 'responseText'
          | 'finished'
          | 'error'
          | 'createdAt'
          | 'updatedAt'
        > & {
          usage?: Types.Maybe<
            Pick<
              Types.AIInferenceStreamUsage,
              | 'cacheCreationInputTokens'
              | 'cacheReadInputTokens'
              | 'durationSeconds'
              | 'inputTokens'
              | 'modelID'
              | 'outputTokens'
            >
          >;
          toolInvocations?: Types.Maybe<
            Array<
              Pick<
                Types.AIToolInvocation,
                | 'id'
                | 'toolName'
                | 'metadata'
                | 'approvedAt'
                | 'rejectedAt'
                | 'rejectReason'
                | 'timedOutAt'
              >
            >
          >;
          riskScoreEvidence?: Types.Maybe<
            Pick<
              Types.RiskScoreEvidence,
              | 'aggregateBenignIndicatorsFormula'
              | 'aggregateBenignIndicatorsScore'
              | 'aggregateRiskyIndicatorsFormula'
              | 'aggregateRiskyIndicatorsScore'
              | 'benignThreshold'
              | 'classification'
              | 'classificationReasoning'
              | 'normalizedTotalRiskFormula'
              | 'normalizedTotalRiskScore'
              | 'riskyThreshold'
            > & {
              benignIndicators: Array<
                Pick<
                  Types.RiskIndicator,
                  | 'contextWeighting'
                  | 'description'
                  | 'evidenceConfidence'
                  | 'riskScore'
                  | 'temporalRelevance'
                >
              >;
              riskyIndicators: Array<
                Pick<
                  Types.RiskIndicator,
                  | 'contextWeighting'
                  | 'description'
                  | 'evidenceConfidence'
                  | 'riskScore'
                  | 'temporalRelevance'
                >
              >;
            }
          >;
        };
      }>;
      pageInfo: Pick<Types.CursorBasedPaginationPageInfo, 'hasNextPage' | 'endCursor'>;
    };
  };
};

export const AIConversationDocument = gql`
  query AIConversation($id: ID!, $streamsInput: AIConversationStreamsInput) {
    aiConversation(id: $id) {
      id
      title
      private
      saved
      canEdit
      isOwner
      createdAt
      updatedAt
      createdBy {
        ...ActorTeaser
      }
      streams(input: $streamsInput) {
        edges {
          node {
            streamId
            userPrompt
            responseText
            finished
            error
            createdAt
            updatedAt
            usage {
              cacheCreationInputTokens
              cacheReadInputTokens
              durationSeconds
              inputTokens
              modelID
              outputTokens
            }
            toolInvocations {
              id
              toolName
              metadata
              approvedAt
              rejectedAt
              rejectReason
              timedOutAt
            }
            riskScoreEvidence {
              aggregateBenignIndicatorsFormula
              aggregateBenignIndicatorsScore
              aggregateRiskyIndicatorsFormula
              aggregateRiskyIndicatorsScore
              benignIndicators {
                contextWeighting
                description
                evidenceConfidence
                riskScore
                temporalRelevance
              }
              benignThreshold
              classification
              classificationReasoning
              normalizedTotalRiskFormula
              normalizedTotalRiskScore
              riskyIndicators {
                contextWeighting
                description
                evidenceConfidence
                riskScore
                temporalRelevance
              }
              riskyThreshold
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
  ${ActorTeaser}
`;

/**
 * __useAIConversation__
 *
 * To run a query within a React component, call `useAIConversation` and pass it any options that fit your needs.
 * When your component renders, `useAIConversation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAIConversation({
 *   variables: {
 *      id: // value for 'id'
 *      streamsInput: // value for 'streamsInput'
 *   },
 * });
 */
export function useAIConversation(
  baseOptions: Apollo.QueryHookOptions<AIConversation, AIConversationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AIConversation, AIConversationVariables>(AIConversationDocument, options);
}
export function useAIConversationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AIConversation, AIConversationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AIConversation, AIConversationVariables>(
    AIConversationDocument,
    options,
  );
}
export function useAIConversationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<AIConversation, AIConversationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AIConversation, AIConversationVariables>(
    AIConversationDocument,
    options,
  );
}
export type AIConversationHookResult = ReturnType<typeof useAIConversation>;
export type AIConversationLazyQueryHookResult = ReturnType<typeof useAIConversationLazyQuery>;
export type AIConversationSuspenseQueryHookResult = ReturnType<
  typeof useAIConversationSuspenseQuery
>;
export type AIConversationQueryResult = Apollo.QueryResult<AIConversation, AIConversationVariables>;
export function mockAIConversation({
  data,
  variables,
  errors,
}: {
  data: AIConversation;
  variables?: AIConversationVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: AIConversationDocument, variables },
    result: { data, errors },
  };
}
